<!-- 发布培训方案 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap" v-if="firstStep"> 
        <el-row class="mg-b-20">培训详情设置</el-row>           
        <organizer :publishId="publishId"></organizer>  
        <add-train :publishId="publishId" ></add-train>
        <el-row class="red">请先添加设置协办方、培训城市、培训讲师，最后点完成按钮！</el-row>
        <el-button round type="danger" @click="toTrainQuery" 
            class="pub-submit">
            完成
        </el-button>
    </div>
    <div class="detail-wrap" v-else>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">                   
            <el-row >
                <el-col :span="12">
                    <el-form-item label="培训标题" prop="title">
                        <el-input type="text" v-model="ruleForm.title" placeholder="请输入内容"/>
                    </el-form-item> 
                </el-col>
                <el-col :span="12">
                    <el-form-item label="培训费用" prop="fee">
                        <el-input type="text" v-model="ruleForm.fee" placeholder="请输入内容">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-col> 
            </el-row>           
            <el-row>
                <el-col :span="12">
                    <el-form-item label="主办方名称" prop="hostName">
                        <el-autocomplete style="width: 100%;"
                            class="inline-input"
                            v-model="ruleForm.hostName"
                            :fetch-suggestions="querySearchHost"
                            placeholder="请输入主办方名称"
                            :trigger-on-focus="false"
                            @select="handleSelectHostName"
                        ></el-autocomplete>
                        <!-- <el-input v-model="ruleForm.hostName"  placeholder="请输入主办方名称" 
                        @blur="getSearchHost(ruleForm.hostName)"/> -->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="承办方名称" prop="undertakeName">
                        <el-autocomplete style="width: 100%;"
                            class="inline-input"
                            v-model="ruleForm.undertakeName"
                            :fetch-suggestions="querySearcUndertakeName"
                            placeholder="请输入承办方名称"
                            :trigger-on-focus="false"
                            @select="handleSelectUndertakeName"
                        ></el-autocomplete>
                        <!-- <el-input v-model="ruleForm.undertakeName"  
                        placeholder="请输入承办方名称" @blur="getSearchUndertake(ruleForm.undertakeName)"/> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="联系方式" prop="phone">
                        <el-input type="text" v-model="ruleForm.phone" placeholder="请输入内容"/>
                    </el-form-item> 
                </el-col>
            </el-row>
            <el-row>
                <el-form-item label="培训内容" prop="content">
                    <el-input type="textarea" v-model="ruleForm.content" 
                    :rows="5" placeholder="请输入内容"/> 
                    <el-upload  
                        ref="coverPicUpload1" action="" 
                        list-type="picture" 
                        accept="image/*"
                        multiple :limit="1" name="file" 
                        :file-list="fileList1"
                        :on-remove="handleRemove1"
                        :http-request="handleRequest1"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                </el-upload>                     
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="培训须知" prop="notice">
                    <el-input type="textarea" v-model="ruleForm.notice" 
                    :rows="5" placeholder="请输入内容"/>  
                    <el-upload  
                        ref="coverPicUpload2" action="" 
                        list-type="picture" 
                        accept="image/*"
                        multiple :limit="1" name="file" 
                        :file-list="fileList2"
                        :on-remove="handleRemove2"
                        :http-request="handleRequest2"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                </el-upload>                     
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="学员权益" prop="equity">
                    <el-input type="textarea" v-model="ruleForm.equity" 
                    :rows="5" placeholder="请输入内容"/>
                    <el-upload  
                        ref="coverPicUpload3" action="" 
                        list-type="picture" 
                        accept="image/*"
                        multiple :limit="1" name="file" 
                        :file-list="fileList3"
                        :on-remove="handleRemove3"
                        :http-request="handleRequest3"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                </el-upload>                       
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="课堂纪律" prop="discipline">
                    <el-input type="textarea" v-model="ruleForm.discipline" 
                    :rows="5" placeholder="请输入内容"/>                       
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="自愿参培承诺书" prop="letter">
                    <el-input type="textarea" v-model="ruleForm.letter" 
                    :rows="8" placeholder="请输入内容"/>                       
                </el-form-item>
            </el-row>
            <el-row>
            <el-form-item>
                <el-button round block type="primary" @click="submitForm('ruleForm')" 
                class="pub-submit" :disabled="disabled">
                    下一步
                </el-button>
            </el-form-item>
        </el-row>
        </el-form>            
    </div>
</div>    

</template>

<script>
import list from '@/config/trainDes'
import list2 from '@/config/trainDes2'
import PageBack from '@/components/PageHeader'
import areaList from '@/assets/js/city'
import Organizer from './components/organizer'
import Lecturer from './components/lecturer'
import AddTrain from './components/addTrainDialog'
export default {
    components:{
        PageBack,
        Organizer,
        Lecturer,
        AddTrain
    },
    data() {
        const selectAddress = (rule,value,callback)=>{
            if(this.ruleForm2.provinces === ''){
                callback(new Error('请选择省份'))
            }else if( this.ruleForm2.city === ''){
                callback(new Error('请选择城市'))
            }else{
                callback()
            }
        }
        return {
            loading: false,
            firstStep: false,
            sencondStep: true,
            showAddTrainDialog:false,
            titleForm:'',
            rules:{
                title:[
                    { required: true, message: '请输入培训标题', trigger: 'blur' },
                ],
                fee:[
                    { required: true, message: '请输入培训费用', trigger: 'blur' },
                ],
                content:[
                    { required: true, message: '请输入培训内容', trigger: 'blur' },
                ],
                notice:[
                    { required: true, message: '请输入培训须知', trigger: 'blur' },
                ],
                equity:[
                    { required: true, message: '请输入学员权益', trigger: 'blur' },
                ],
                discipline:[
                    { required: true, message: '请输入课堂纪律', trigger: 'blur' },
                ],
                letter:[
                    { required: true, message: '请输入自愿参培承诺书', trigger: 'blur' },
                ],
                eventPlace:[
                    { required: true, message: '请输入培训地点', trigger: 'blur' },
                ],
                area: [
                    { required: true, validator: selectAddress,
                        message: '请选择地区', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入培训人数', trigger: 'blur' },
                ],
                signTime: [
                    { required: true, message: '请输入签到时间', trigger: 'blur' },
                ],
                applyDate: [
                    { required: true, message: '请选择报名日期', trigger: 'change' },
                ],
                applyTime: [
                    { required: false, message: '请选择报名时间', trigger: 'change' },
                ],
                eventDate: [
                    { required: true, message: '选择培训日期', trigger: 'change' },
                ],
                eventTime: [
                    { required: true, message: '选择培训时间', trigger: 'change' },
                ],
            },
            ruleForm: list,
            ruleForm2: list2,
            disabled: false,
            url: '',
            publishId: '',
            userInfoOption: [],
            areaList: areaList.provinces,
            cityList: [],
            trainId: '',
            hostInfoOption: [],
            underTakeInfoOption: [],            
            fileList1: [],
            fileList2: [],
            fileList3: [],
            
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    created() {
        this.publishId = this.$route.query.id
        this.type = this.$route.query.type || '' 
        if(this.publishId){
            this.initData()
        }
    },
    mounted() {

    },
    methods: {
        initData(){
            let params = {
                    opcode: this.$code.TrainQuery,
                    i_serial_train: this.publishId,
                    v_train_title: '',
                    c_status: '',
                    start_date: this.startDate,
                    end_date: this.endDate,
                    pagesize: 10,
                    page: 1,
                }
                this.loading = true
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                    let result = res.Data.DataTable

                    let list = result.map(item=>{
                         return{
                            title: item['培训主题'],
                            content: item['培训内容'],
                            fee: item['培训费用'],
                            equity: item['学员权益'],
                            undertakeName: item['承办单位名称'],
                            hostName: item['主办单位名称'],
                            notice: item['报名须知'],
                            discipline: item['课堂纪律'],
                            letter: item['自愿参培承诺书'],
                            serialTrain: item['培训标识'],
                            status: item['培训状态'],
                            image1: item['图片1'],
                            image2: item['图片2'],
                            image3: item['图片3'],
                            phone: item['备注'],
                         }   
                    })
                    this.ruleForm = list[0]
                    this.fileList1 = [ {name: '',url: this.ruleForm.image1 }]
                    this.fileList2 = [ {name: '',url: this.ruleForm.image2 }]
                    this.fileList3 = [ {name: '',url: this.ruleForm.image3 }]
                    // console.log(this.ruleForm,this.fileList1)
                }else{

                }        
            })
        },        
        submitForm(formName){
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.handleSubmit()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleSubmit(){
            let { title,content,fee,notice,letter,equity,discipline, image1,image2,image3,
                hostName,hostNo,undertakeNo,undertakeName,phone} = this.ruleForm
            let opcode = this.publishId ? this.$code.TrainUpdate : this.$code.TrainAdd
            let params = {}
            let addParams = {
                opcode: opcode,
                v_train_title: title,
                v_train_content: content,
                v_train_cost: fee,
                v_registration_notice: notice,
                v_interest: equity,
                v_discipline: discipline,
                v_letter_commitment: letter,
                i_image: image3,
                i_image1: image1,
                i_image2: image2,
                v_remarks: phone,
                i_host_no: hostNo,
                v_host_name: hostName,
                i_undertake_no: undertakeNo,
                v_undertake_name: undertakeName,    
            }
            let updateParams = {
                i_serial_train: this.publishId,
            }
            if(this.publishId){
                console.log("更新")
                params =  Object.assign({}, addParams, updateParams)
            }else{
                console.log("新增")
                params = addParams
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) { 
                    console.log('发布成功',res)
                    let  serial = ''
                    if(this.publishId ){
                        serial = this.publishId
                    }else{
                        serial = this.splitStr(res.Message) 
                    }
                    this.disabled = true 
                    this.firstStep = true                    
                    this.$message.success(res.Message)
                    this.publishId = serial                   
                }else{
                    this.$message.error(res.Message)
                }
            })    
        },
        // 培训详情设置
        trainForm(formName){
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.trainSubmit()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // 培训详情设置 提交
        trainSubmit(){
            let {eventPlace, provinces,city, amount,signTime,applyStartDate,applyEndDate,eventStartDate,eventStartTime,eventEndTime} = this.ruleForm2
            // 修改 TrainDesUpdate  新增 TrainDesSetting
            let opcode = this.publishId && this.type==='edit'? this.$code.TrainDesUpdate : this.$code.TrainDesSetting  
            let params = {}
            let addParams = {
                opcode: opcode,
                i_serial_train: this.publishId,
                i_start_entry: applyStartDate,
                i_end_entry: applyEndDate,
                i_start_date: eventStartDate,
                i_end_date: eventEndDate,
                i_start_time: eventStartTime,
                i_end_time: eventEndTime,
                v_economize: provinces,
                v_city: city,
                v_location: eventPlace,
                n_peoples: amount,
                i_timer: signTime,
            }
            let updateParams = {
                id: '',
            }
            if(this.publishId && this.type === 'edit'){
                console.log("更新")
                params =  Object.assign({}, addParams, updateParams)
            }else{
                console.log("新增")
                params = addParams
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) { 
                    console.log('培训详情设置成功',res)
                    let  serial = ''
                    if(this.publishId ){
                        // serial = this.publishId
                    }else{
                        // 培训详情序号
                        serial = this.splitStr(res.Message) 
                    }
                    this.trainId = serial 
                    this.sencondStep = true                    
                    this.$message.success('培训详情设置成功')
                                      
                }else{
                    this.$message.error(res.Message)
                }
            })    
        },
        async querySearchHost(queryString, cb){
            let result = queryString ? await this.fetchData(queryString) : []  
            cb(result)
        },
        handleSelectHostName(item){
            this.ruleForm.hostName = item.username
            this.ruleForm.hostNo = item.userId
        },
        async querySearcUndertakeName(queryString, cb){
            let result = queryString ? await this.fetchData(queryString) : []  
            cb(result)
        },
        handleSelectUndertakeName(item){
            this.ruleForm.undertakeName = item.username
            this.ruleForm.undertakeNo = item.userId
        },
        // 模糊搜索查询
        fetchData(value){
            return new Promise((resolve,reject)=>{
                if(value.length >1){
                let params = {
                    opcode: this.$code.UserInfoSearch,
                    v_name: value,
                    v_caption: '',
                    v_phone: '',
                }
                // 查询账户信息
                this.$api._requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length > 0){
                            let list = result.map(item=>{
                                return{
                                    userId: item['会员账号'],
                                    value: item['姓名']+'-'+ item['手机号'],
                                    username: item['姓名'],
                                    phone: item['手机号'],
                                    role: item['角色'],
                                }
                            })   
                            resolve(list)
                        }else{
                            reject([])
                        }
                    }
                }).catch(err => {
                   
                })
            }
            })            
        },
        // 模糊搜索查询主办方
        getSearchUndertake(value){
            if(value.length >1){
                let params = {
                    opcode: this.$code.UserInfoSearch,
                    v_name: value,
                    v_caption: '',
                    v_phone: '',
                }
                // 查询账户信息
                this.$api._requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length > 0){
                            this.underTakeInfoOption = result.map(item=>{
                                return{
                                    value:item['会员账号'],
                                    label: item['会员账号'],
                                    phone: item['手机号'],
                                    role: item['角色'],
                                }
                            })                            
                        }else{
                            this.ruleForm.undertakeName = ''
                            this.underTakeInfoOption = []
                        }
                    }
                }).catch(err => {
                   
                })
            }
        },
        // 截图中括号里面的赛事标识符
        splitStr(str){
            let result = ''
            if(str){
                const regex = /\[([^\]]+)\]/g;
                let match = regex.exec(str)
                result = match[1]
            }           
            return result
        },
        selectApplyDate(value){
            this.ruleForm2.applyStartDate  = value[0].replace(/-/g, '')
            this.ruleForm2.applyEndDate  = value[1].replace(/-/g, '')
        },
        selectApplyTime(value){
            this.ruleForm2.applyStartTime  = value[0].replace(/:/g, '')
            this.ruleForm2.applyEndTime  = value[1].replace(/:/g, '')
        },   
        selectEventDate(value){
            this.ruleForm2.eventStartDate = value.replace(/-/g, '')
            // console.log(this.ruleForm2.eventStartDate)
        },
        selectEventTime(value){
            this.ruleForm2.eventStartTime  = value[0].replace(/:/g, '')
            this.ruleForm2.eventEndTime  = value[1].replace(/:/g, '')
        },
        toTrainQuery(){
            this.$router.push('/trainQuery')            
        },
        handleChangeArea(value){
            this.cityList = []
            this.ruleForm2.provinces = value
            this.ruleForm2.city = ''
            let cityObj = this.areaList.filter(i=> i.label === value)
            this.cityList = cityObj[0].cities
        },
        handleChangecity(value){
            this.ruleForm2.city = value
        },
        async handleRequest1(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.image1 = this.$global.uploadUrl + url
            this.fileList1 = [
                {name:file.file.name,url: this.ruleForm.image1 }
            ]
            this.loading.close();
            this.$refs.coverPicUpload1.clearFiles()
        },  
        async handleRequest2(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.image2 = this.$global.uploadUrl + url
            this.fileList2 = [
                {name:file.file.name,url: this.ruleForm.image2 }
            ]
            this.loading.close();
            this.$refs.coverPicUpload2.clearFiles()
        },  
        async handleRequest3(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.image3 = this.$global.uploadUrl + url
            this.fileList3 = [
                {name:file.file.name,url: this.ruleForm.image3 }
            ]
            this.loading.close();
            this.$refs.coverPicUpload3.clearFiles()
        },  
        handleRemove1(file, fileList) {
            this.ruleForm.image1 = ''
            this.fileList1 = []
        },
        handleRemove2(file, fileList) {
            this.ruleForm.image2 = ''
            this.fileList2 = []
        },
        handleRemove3(file, fileList) {
            this.ruleForm.image3 = ''
            this.fileList3 = []
        },     
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        handleUploadError() {
            // this.loading = false
            // this.$message({
            //     type: "error",
            //     message: "上传失败",
            // });
            // this.loading.close();
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap {
    width: 1000px;
    font-size: 16px;
    line-height: 28px;
}
.pub-submit{
    margin-top: 16px;
    width: 30%;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/training/train.vue